import createStore from "astrid-helpers/src/createStore";

export const [getBuffering, setBuffering, useBuffering, onBuffering] = createStore(false);
